// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Ouroboros_Models_Documents_PromoCodeErrorPhase from "../Ouroboros.Models.Documents.PromoCodeErrorPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_ChooseSubscription from "../Ouroboros.Programs.Controllers.ChooseSubscription/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var promoCodeErrorPhaseFromOption = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return Ouroboros_Models_Documents_PromoCodeErrorPhase.promoCodeErrorPhaseNamespace.hidden;
})(function (v) {
    return Ouroboros_Models_Documents_PromoCodeErrorPhase.promoCodeErrorPhaseNamespace.visible;
});
var promoCodeErrorMessageFromOption = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return "";
})(/* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn));
var buildChooseSubscriptionViewProps = function (input) {
    return {
        subscriptionStatus: input.subscriptionStatus,
        loading: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.selectionLoading)),
        loadingPromo: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.promoLoading)),
        promoCodeErrorPhase: promoCodeErrorPhaseFromOption(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.promoCodeError))),
        promoCodeErrorMessage: promoCodeErrorMessageFromOption(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.promoCodeError))),
        onPackageSelection: function (plan) {
            return Ouroboros_Programs_Controllers_ChooseSubscription.runChooseSubscriptionAction(input.kernel.controller.onPackageSelection(plan));
        },
        onApplyPromoCode: function (rawCode) {
            return Ouroboros_Programs_Controllers_ChooseSubscription.runChooseSubscriptionAction(input.kernel.controller.onApplyPromoCode(rawCode));
        }
    };
};
export {
    buildChooseSubscriptionViewProps
};
//# sourceMappingURL=index.js.map
